import React, { memo } from 'react'
import classNames from 'classnames'
import viewProjectConnector from 'root/src/client/logic/project/connectors/viewProjectConnector'
import withModuleContext from 'root/src/client/util/withModuleContext'
import { comparePropsFn } from 'root/src/shared/util/stateCompare'
import styles from './styles'
import DareDetailsWrapper from './DareDetailsWrapper'
import AssigneesSection from './AssigneesSection'

const ViewProject = (props) => {
	const { classes } = props
	return (
		<div className={classNames(classes.root, 'layout-row layout-align-center')}>
			<div className={classes.contentContainer}>
				<DareDetailsWrapper {...props} />
				<AssigneesSection {...props} />
			</div>
		</div>
	)
}

const memoProps = [
	'auditFavorites', 'myFavorites', 'projectDescription', 'projectTitle', 'pledgeAmount', 'assignees',
	'gameImage', 'classes', 'isAuthenticated', 'canEditProjectDetails', 'updateProject',
	'pledgers', 'timeLeft', 'projectDeliveries', 'goalAmount', 'projectShareUrl', 'projectUrl',
	'projectAcceptanceStatus', 'canRejectActiveProject', 'canApproveProject', 'canRejectProject',
	'displayModal', 'moduleId', 'games', 'isMobileRes', 'authenticateTwitch', 'claimSponsoredProject',
	'reportCtaClick', 'projectId', 'isFeatured', 'landingShortUrl', 'campaignId', 'isSubmittable',
]

export default withModuleContext(
	viewProjectConnector(memo(ViewProject, comparePropsFn(memoProps)), styles, 'MuiViewProject'),
)
